import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PricingScan } from './components/PricingScan';
export function AppRouter() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/prijsscan" element={<PricingScan data-id="element-3" />} data-id="element-2" />
        <Route path="*" element={<Navigate to="/prijsscan" replace data-id="element-5" />} data-id="element-4" />
      </Routes>
    </BrowserRouter>;
}